import { AdPlatformType } from '@app/core/models/common.models';
import { CustomerFeature, InvoiceCurrency } from '@app/core/models/customer.models';

export enum ThirdPartyPlatform {
  MerchantSpring = 'MERCHANTSPRING',
}

export const ThirdPartyPlatformFeatureMap = {
  [ThirdPartyPlatform.MerchantSpring]: CustomerFeature.MerchantSpring,
};

export enum ThirdPartyAccessStatus {
  Ok = 'OK',
  NoAccess = 'NO-ACCESS',
}

export interface ThirdPartyAccount {
  customerId: number;
  thirdPartyPlatform: ThirdPartyPlatform;
  accessStatus: ThirdPartyAccessStatus;
  accounts?: { accountId: string; accountName: string }[];
  createdAt: Date;
  archivedAt?: Date;
  daysUntilArchival?: number;
  billingAmount?: number | null;
  billingCurrency?: InvoiceCurrency;
}

export interface IntegrationData {
  thirdPartyPlatform: ThirdPartyPlatform;
  recommendedFor?: AdPlatformType | AdPlatformType[];
  logo: string;
  disabled?: boolean;
  price?: number;
}

export type ThirdPartyIntegration = ThirdPartyAccount & IntegrationData;

export const integrations: IntegrationData[] = [
  {
    thirdPartyPlatform: ThirdPartyPlatform.MerchantSpring,
    logo: 'merchant-spring.png',
    recommendedFor: AdPlatformType.Amazon,
  },
];

export const integrationCleanUpTime = 8;
